module.exports = __webpack_public_path__ + "static/media/banner-2.70ae3417.png";